// extracted by mini-css-extract-plugin
export default {"sectionContainer":"styles_sectionContainer__lfYsn","containerOfActivities":"styles_containerOfActivities__mRjL-"};